import {createContext,useCallback,useContext,useMemo,useReducer} from "react"
import {readDocs} from "../firebase.js"

export const Context = createContext()
const photos = []

const initialState = {
  items: photos,
  placeholders: photos,
  count: photos.length,
  inputs: { comment: null, file: null, path: null },
  isCollapsed: false
}
function handleOnChange(state, e){
  if (e.target.name === "file") {
    return {
      ...state.inputs,
      file: e.target.files[0],
      path: URL.createObjectURL(e.target.files[0])
    }
  } 
  else return { ...state.inputs, comment: e.target.value }
}
function reducer(state, action) {
  switch (action.type) {
    case "setItem":
      return {
        ...state,
        items: [state.inputs, ...state.items],
        placeholders: [state.inputs, ...state.items],
        count: state.items.length + 1,
        inputs: { comment: null, file: null, path: null }
      }
    case "filterItems":
      return {
        ...state,
        items: action.payload.results
      }
    case "setItems":
      return {
        ...state,
        items: action.payload.items,
        placeholders: action.payload.items
      }
    case "setInputs":
      return {
        ...state,
        inputs: handleOnChange(state, action.payload.value)
      }
    case "collapse":
      return {
        ...state,
        isCollapsed: action.payload.bool,
        inputs: { comment: null, file: null, path: null }
      }
    default:
      return state
  }
}
export default function Provider({ children }){
  const [state, dispatch] = useReducer(reducer, initialState)
  const read = useCallback(async () => {
    const items = await readDocs("comments")
    dispatch({ type: "setItems", payload: { items } })
  }, [])
  const filterItems = useCallback((input) => {
    if (input === "" || input) {
      dispatch({ type: "setItems", payload: { items: state.placeholders } })
    }
    let list = state.placeholders.flat()
    let results = list.filter((item) => {
      const name = item.comment.toLowerCase()
      const searchInput = input.toLowerCase()
      return name.indexOf(searchInput) > -1
    })
    dispatch({ type: "filterItems", payload: { results } })
  },[state.placeholders])
  const value = useMemo(() => {
    return {state,dispatch,read,filterItems}
  }, [state, dispatch, read, filterItems])
  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  )
}
export function useFirestoreContext(){
  return useContext(Context)
}